<template>
    <div>
        <TributeSettings
            class="mt-6"
            v-if="token"
            ref="tributeSettings"
            mode="global"
            :token="token"
            :funeralHomeId="funeralHomeId"
            @loading="val => (loading = val)"
        />

        <div class="py-5 d-flex justify-end">
            <v-btn @click="submitSaveSettings" depressed color="primary" :dark="!loading" :disabled="loading"
                >Save</v-btn
            >
        </div>
    </div>
</template>
<script>
import TributeSettings from '@/components/Tribute/TributeSettings.vue';
export default {
    data() {
        return {
            loading: false,
            token: null,
        };
    },
    components: { TributeSettings },
    props: {
        funeralHomeId: {
            type: Number,
            required: true,
        },
    },
    methods: {
        async setAuthToken() {
            const response = await this.$auth.getIdTokenClaims();
            this.token = response.__raw;
        },
        submitSaveSettings() {
            if (this.$refs.tributeSettings) {
                this.$refs.tributeSettings.saveSettings();
            }
        },
    },
    async mounted() {
        this.setAuthToken();
    },
};
</script>
<style lang=""></style>
